import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { useEffect } from "react";
import authImage from "../assets/image/Authentication-pana.svg";
import "./Login.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BaseURL from "../Util/BaseURL";
import toastify from "../Util/toastify";
const Login = () => {
  sessionStorage.clear();
  var nav = useNavigate();
  const [userName, setuserName] = useState("");
  const [userPassword, setPassword] = useState("");

  async function role() {
    const r = await axios.get(`${BaseURL}FindByName?name=${userName}`);
    var data = r.data[0].role[0].roleName;
    sessionStorage.setItem("c", data);
  }

  const init = async () => {
    const res = await axios.post(`${BaseURL}authenticate`, {
      userName,
      userPassword,
    }).catch(function (error) {
      if (error.response.status === 401) {
        toastify("Invalid Credentials","error")
       setuserName("")
       setPassword("")
      }
      if(error.response.status === 500){
        toastify("Server Error","error")
       setuserName("")
       setPassword("")
      }
    })
    if (res.status === 200)
    {
      role()
      sessionStorage.setItem("user", res.data.user.userName);
    const data = res.data.jwtToken;
    sessionStorage.setItem("pic", data);
      if (sessionStorage.getItem("user") === "Seller") nav("/SellerPanel");
      else if (sessionStorage.getItem("user") === "admin") nav("/AdminPanel");
      else if (sessionStorage.getItem("user") === "Distribution Hub")
        nav("/DistributionHubPanel");
      else if (sessionStorage.getItem("user") === "Delivery Boy")
        nav("/DeliveryBoyPanel");
      else nav("/");
    }
    else
     {
      
     }
  };
  function navigate() {
    nav("/Register");
  }

  function validateForm() {
    let name = document.getElementById("userName").value;
    let password = document.getElementById("password").value;
    let noErr = true;
    if (name.length == 0) {
      toastify("Username should not be empty","error");
      noErr = false;
    } else {
      if (name.length === 0) {
        toastify("Username should not be empty","error");
        noErr = false;
      } else {
        noErr = true;
      }
    }
    if (password.length < 1) {
      toastify("Password should not be empty","error");
      noErr = false;
    } else {
      if (password.length < 1) {
        toastify("Password should not be empty","error");
        noErr = false;
      } else {
        if(noErr === true)
           noErr = true;
      }
    }
    if (noErr === true) {
      init();
    }
  }

  return (
    <div className="reg">
      <div className="container register ">
        <div className="row">
          <div className="w-50 d-none d-xl-block d-lg-block d-md-block">
            <img
              onClick={() => nav("/")}
              className="w-75"
              style={{ marginLeft: "65%", marginBottom: "10%" }}
              src="https://res.cloudinary.com/vcart/image/upload/v1658298828/Screenshot__131_-removebg-preview_mtjdmd.png"
              alt=""
            />
          </div>

          <div className="col-md-9 mx-auto d-none d-xl-block d-lg-block d-md-block register-right">
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <h3 className="register-heading">Login</h3>
                <div className="row register-form">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="userName"
                        className="form-control"
                        placeholder="User Name *"
                        value={userName}
                        onChange={(e) => setuserName(e.target.value)}
                      />
                      <div className="error" id="userNameError"></div>
                      <br></br>
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        id="password"
                        className="form-control"
                        placeholder="Password *"
                        value={userPassword}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <div className="error" id="passwordError"></div>
                      <br></br>
                    </div>
                    <button
                      className="btn btn-primary login"
                      onClick={validateForm}
                    >
                      Login
                    </button>
                    <button className="btn btn-primary" onClick={navigate}>
                      Register
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-100 d-block d-xl-none d-lg-none d-md-none">
            <img
              onClick={() => nav("/")}
              className="w-75"
              style={{ marginLeft: "15%", marginBottom: "10%" }}
              src="https://res.cloudinary.com/vcart/image/upload/v1658298828/Screenshot__131_-removebg-preview_mtjdmd.png"
              alt=""
            />
          </div>
          <div className="d-block d-xl-none d-lg-none d-md-none w-75 mx-auto register-right">
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <h3 className="register-heading">Login</h3>
                <div className="row register-form">
                  <div className="">
                    <div className="form-group">
                      <input
                        type="text"
                        id="userName"
                        className="form-control"
                        placeholder="User Name *"
                        value={userName}
                        onChange={(e) => setuserName(e.target.value)}
                      />
                      <div className="error" id="userNameError"></div>
                      <br></br>
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        id="password"
                        className="form-control"
                        placeholder="Password *"
                        value={userPassword}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <div className="error" id="passwordError"></div>
                      <br></br>
                    </div>
                    <button className="btn btn-primary" onClick={validateForm}>
                      Login
                    </button>
                    <button className="btn btn-primary" onClick={navigate}>
                      Register
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
